/**
 * @generated SignedSource<<bf6dc80f06802ab9781f807862a62901>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutHelp_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutHelpContent_buyer">;
  readonly " $fragmentType": "CheckoutHelp_buyer";
};
export type CheckoutHelp_buyer$key = {
  readonly " $data"?: CheckoutHelp_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutHelp_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutHelp_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutHelpContent_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "448add4e8a8e5d6c5eb3a3977f6468ae";

export default node;
